import { ReactComponent as Arrow } from "assets/console/arrow_outward_gray.svg";
import { Link } from "react-router-dom";

type PageHeaderProps = {
    category: string;
    title?: string;
    linkTo?: string;
};
export default function PageHeader({ category, title, linkTo }: PageHeaderProps) {
    return (
        <div className="flex justify-between px-[40px] py-[20px] border-b border-[#dddddd] overflow-x-auto">
            <div className="flex items-center min-h-[43px]">
                <h2 className="text-[#222222] text-[24px] font-bold whitespace-nowrap">{category}</h2>
                {title && (
                    <>
                        <span className="w-[10px] h-[10px] border border-[5px] border-transparent border-l-[#dddddd] m-[0_15px_0_20px]"></span>
                        <h3 className="text-[#222222] text-[18px] font-[500] whitespace-nowrap">{title}</h3>
                    </>
                )}
            </div>
            {linkTo && (
                <Link
                    to={linkTo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border border-[#dddddd] rounded-[19px] text-[#666666] font-[500] px-[12px] py-[8.5px] flex items-center gap-[13px] whitespace-nowrap ml-5"
                >
                    사용자화면 바로가기
                    <Arrow />
                </Link>
            )}
        </div>
    );
}
